import { CanActivateFn } from '@angular/router'

export const canActivateLanding: CanActivateFn = () => {
  // Clear stale previousURL to prevent blocking on page refresh
  if (sessionStorage.getItem('previousURL') === 'signin') {
    sessionStorage.removeItem('previousURL')
  }
  return true
}
